import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { FeatureService } from '@app/shared/services/feature.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({ selector: '[isFeatureAvailable]' })
export class IsFeatureAvailableDirective implements OnInit, OnChanges, OnDestroy {
  @Input('isFeatureAvailable') public key: string;
  @Input() public nodeType?: string;
  @Input() public picVersion?: number;
  @Input() public nordicVersion?: number;

  private readonly onDestroy$ = new Subject<void>();
  private checkSubscription?: Subscription;
  private placeholder: unknown = null;
  private isRemoved = false;

  constructor(
    private readonly featureService: FeatureService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef
  ) {}

  ngOnInit(): void {
    this.checkFeature();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['key'] || changes['nodeType'] || changes['picVersion'] || changes['nordicVersion']) {
      this.checkFeature();
    }
  }

  ngOnDestroy(): void {
    this.checkSubscription?.unsubscribe();
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private checkFeature(): void {
    this.checkSubscription?.unsubscribe();
    if (!this.key) {
      return;
    }
    this.checkSubscription = this.featureService
      .isAvailable(this.key, this.nodeType, this.picVersion, this.nordicVersion)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((isAvailable) => {
        if (isAvailable) {
          this.showFeature();
        } else {
          this.removeFeature();
        }
      });
  }

  removeFeature(): void {
    if (this.isRemoved) {
      return;
    }
    const el = this.el.nativeElement;
    const parent = this.renderer.parentNode(el);
    if (parent) {
      this.placeholder = this.renderer.createComment('isFeatureAvailable');
      this.renderer.insertBefore(parent, this.placeholder, el);
      this.renderer.removeChild(parent, el);
      this.isRemoved = true;
    }
  }

  showFeature(): void {
    if (!this.isRemoved) {
      return;
    }
    const el = this.el.nativeElement;
    if (this.placeholder) {
      const parent = this.renderer.parentNode(this.placeholder);
      if (parent) {
        this.renderer.insertBefore(parent, el, this.placeholder);
        this.renderer.removeChild(parent, this.placeholder);
        this.placeholder = null;
        this.isRemoved = false;
      }
    }
  }
}

